import { useEffect, useState } from 'react';
import { getCitationSourceApi, type CitationSourceRecord } from './api';
import { citationEntryName } from './lib/citationLinks';
import SourcePdfContent from './SourcePdfContent';
import {useSearchParams} from 'react-router-dom';
import {focusedSourceText} from './lib/sourceFocus';
import ScientificText from './ScientificText';

export default function CitationSource({bookId,page,chunkId}:{bookId:string;page:number;chunkId:string}) {
  const [params]=useSearchParams();
  const [source,setSource]=useState<CitationSourceRecord>();
  const [error,setError]=useState('');
  const [attempt,setAttempt]=useState(0);
  useEffect(()=>{
    const controller=new AbortController();
    setSource(undefined);setError('');
    const timer=window.setTimeout(()=>{controller.abort();setError('引用原文加载超时，请重试');},30000);
    void getCitationSourceApi(chunkId,controller.signal).then(record=>{
      if(controller.signal.aborted)return;
      if(record.book_id!==bookId || record.pdf_page!==page) {setError('引用记录与请求页码不一致，请返回回答重新打开出处');return;}
      setSource(record);
    }).catch(reason=>{if(!controller.signal.aborted)setError(reason instanceof Error?reason.message:'引用原文加载失败');})
      .finally(()=>window.clearTimeout(timer));
    return()=>{controller.abort();window.clearTimeout(timer);};
  },[bookId,page,chunkId,attempt]);
  if(error)return <div className="source-page-state" role="alert"><p>{error}</p><button className="btn" onClick={()=>setAttempt(n=>n+1)}>重新加载引用</button></div>;
  if(!source)return <div className="source-page-state" role="status">正在核对引用记录与原文位置…</div>;
  const focus=focusedSourceText(source.text,(params.get('field')||'').split(','));
  return <>
    <div id="original-pdf"><SourcePdfContent bookId={bookId} page={page} focusText={focus} /></div>
    <details className="citation-original" aria-label="引用片段">
      <summary>核对引用片段 <span>{citationEntryName(source.text) || source.chapter_title || source.book_title}</span></summary>
      <div className="citation-original-text"><ScientificText text={focus} sources={[source.text]} /></div>
      {focus!==source.text && <details><summary>查看完整资料</summary><div className="citation-original-text"><ScientificText text={source.text} /></div></details>}
    </details>
  </>;
}
